import { render } from "./EmtpyDashboard.vue?vue&type=template&id=3216a9f6&scoped=true"
import script from "./EmtpyDashboard.vue?vue&type=script&lang=js"
export * from "./EmtpyDashboard.vue?vue&type=script&lang=js"

import "./EmtpyDashboard.vue?vue&type=style&index=0&id=3216a9f6&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\WebDashBoard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3216a9f6"]])

export default __exports__